import script from "./AssessmentReferral.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentReferral.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentReferral.vue?vue&type=style&index=0&id=3091d504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3091d504"]])

export default __exports__